import * as React from "react";
import axios from "axios";
import styled from "styled-components";
import { connect } from "react-redux";
import { Button, FrameFooter } from "@conserveit/blocks";
import { associateEquipRule } from "../../../redux/modules/_BETA/associate";
import Loading from "../../../components/Loading";
import { AssociateIssueSelect } from "../../../components/AssociateIssueSelect";
import MsgAlert from "../../../components/Alert/Alert";
import { AppState } from "../../../redux/store";
import NoResultsOverlay from "../../../components/NoResultsOverlay";

export const TRIAGE_ACTION_MODAL = "TRIAGE_ACTION_MODAL";

const FullHeightWrapper = styled.div`
  height: 100%;
`;
const StyledFrameFooter = styled(FrameFooter)`
  text-align: right;
`;
interface State {
  issues: Insite.API.Action[];
  error?: string;
  loading: boolean;
}

interface OwnProps {
  equipRuleIds: number[];
  onHide: () => void;
  syncoId: string;
}

interface StateProps {
  user: Insite.AppState["auth"]["user"] & { site: string[]; project: string[] };
  userSites: Insite.AppState["userSites"];
  isAssociating: boolean;
}

interface DispatchProps {
  linkEquipRulesToTicket: (
    equipRuleIds: number[],
    issueKey: string
  ) => ReturnType<typeof associateEquipRule>;
}

// TODO: need to add type for auth state.
function mapStateToProps(state: AppState & { auth: any }): StateProps {
  return {
    isAssociating: state.betaAssociate.isAssociating,
    user: state.auth.user,
    userSites: state.userSites,
  };
}

const mapDispatchToProps: DispatchProps = {
  linkEquipRulesToTicket: (equipRuleIds: number[] = [], issueKey) =>
    associateEquipRule({ equipRuleIds, issueKey }),
};

type Props = OwnProps & StateProps & DispatchProps;

/**
 * Adds the valueString property, which is a composition
 * of all the properties that this data should be
 * searchable on.
 */
function composeIssueData(issues: Insite.API.Action[]) {
  return issues.map((issue) => ({
    ...issue,
    valueString: `${issue.components} ${issue.bonfire_status} ${issue.context} ${issue.description} ${issue.priority} ${issue.responsible} ${issue.spark_type} ${issue.summary} ${issue.target} ${issue.key} ${issue.project_name} ${issue.transition_reason}`,
  }));
}

class AssociateIssueSelectContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      issues: [],
      error: undefined,
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    // tslint:disable-next-line:no-floating-promises
    this.getPendingIssues()
      .then((result) => {
        const filtered =
          result.data.length > 0
            ? result.data.filter((i) => i.bonfire_status !== "Rejected")
            : [];
        const issues = composeIssueData(filtered);
        this.setState({ issues });
      })
      .catch((error) => {
        this.setState({
          error: `Error status: ${error.status}, there is something wrong.`,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  getPendingIssues = (): Promise<{ data: Insite.API.Action[] }> => {
    const { userSites, syncoId } = this.props;
    const site = userSites.sites[syncoId];
    const project = userSites.projects[site.projectId];

    return axios.post("/issues", {
      site: [site.id],
      project: [project.jira_key],
      status: "open",
    });
  };

  render() {
    const { onHide, equipRuleIds, linkEquipRulesToTicket, isAssociating } =
      this.props;

    if (this.state.loading) {
      return <Loading />;
    }

    if (this.state.error !== undefined) {
      return <MsgAlert message={this.state.error} type="error" />;
    }
    return (
      <React.Fragment>
        {this.state.issues.length === 0 && (
          <React.Fragment>
            <FullHeightWrapper>
              <NoResultsOverlay noActionsMessage posRel />
            </FullHeightWrapper>
            <StyledFrameFooter>
              <Button onClick={onHide} appearance="plain">
                Cancel
              </Button>
            </StyledFrameFooter>
          </React.Fragment>
        )}
        {this.state.issues.length !== 0 && (
          <AssociateIssueSelect
            onHide={onHide}
            issues={this.state.issues}
            isAssociating={isAssociating}
            equipRuleIds={equipRuleIds}
            associateEquipRule={linkEquipRulesToTicket}
          />
        )}
      </React.Fragment>
    );
  }
}

const ConnectedAssociateIssueSelectContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssociateIssueSelectContainer);

export { ConnectedAssociateIssueSelectContainer as AssociateIssueSelectContainer };
